import { useMemo } from 'react'

import { getTiktokTrackErrorExistingTiktokCampaignSelector } from 'src/Redux/tiktokTrack-process/selectors'
import { useAppSelector } from 'src/Hooks/redux'
import { useLazySearchTikTokTracksAuthQuery } from 'src/Redux/tiktokTrackSearchApi'
import { ExistingTikTokCampaign } from 'src/Redux/tiktokTrack-process'

interface UseSearchOneTrackAuth {
  searchTikTokTrack: ReturnType<typeof useLazySearchTikTokTracksAuthQuery>[0]
  tikTokSearchErrorMessage: string
  tikTokExistingCampaign: ExistingTikTokCampaign | null
}

export const useSearchOneTrackAuth = (): UseSearchOneTrackAuth => {
  const existingTikTokCampaign = useAppSelector(
    getTiktokTrackErrorExistingTiktokCampaignSelector,
  )

  const [searchTikTokTrack, { error: searchTikTokTrackError }] =
    useLazySearchTikTokTracksAuthQuery()

  const tikTokSearchErrorMessage = useMemo(
    () => (searchTikTokTrackError as { message?: string })?.message || '',
    [searchTikTokTrackError],
  )

  const tikTokExistingCampaign = useMemo(
    () =>
      (
        searchTikTokTrackError as {
          data?: { tiktokCampaignData?: ExistingTikTokCampaign }
        }
      )?.data?.tiktokCampaignData ||
      existingTikTokCampaign ||
      null,
    [searchTikTokTrackError, existingTikTokCampaign],
  )

  return {
    searchTikTokTrack,
    tikTokSearchErrorMessage,
    tikTokExistingCampaign,
  }
}
